// extracted by mini-css-extract-plugin
export default {"image":"H3-z","loaded":"I3-z"};